import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import type { AuditVarianceByGame } from '../../types/auditVarianceTypes';

interface AuditDynamicFormVarianceCountCellProps {
  variance: AuditVarianceByGame | undefined;
}

const AuditDynamicFormVarianceCountCell: React.FC<AuditDynamicFormVarianceCountCellProps> = React.memo(({ variance }) => {
  const status = variance?.status ?? 'unknown';
  const value = variance?.quantityVariance;

  if (status === 'unknown') {
    return (
      <Box
        sx={{
          minWidth: 50,
          width: 50,
          maxWidth: 50,
          px: 1,
          height: '17px',
          maxHeight: '17px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          color: 'text.secondary',
        }}
      >
        <Tooltip title="Run simulation or refresh to view variance" arrow>
          <Typography component="span" sx={{ fontWeight: 600, fontSize: '15px', lineHeight: '17px' }}>
            —
          </Typography>
        </Tooltip>
      </Box>
    );
  }

  const label = typeof value === 'number' ? String(value) : '—';
  const isNegative = typeof value === 'number' && value < 0;

  return (
    <Box
      sx={{
        minWidth: 50,
        width: 50,
        maxWidth: 50,
        px: 1,
        height: '17px',
        maxHeight: '17px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: 600,
          fontSize: '15px',
          color: isNegative ? 'error.main' : (status === 'match' ? 'text.secondary' : '#2C6CA0'),
          lineHeight: '17px',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
});

AuditDynamicFormVarianceCountCell.displayName = 'AuditDynamicFormVarianceCountCell';

export default AuditDynamicFormVarianceCountCell;
